var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "home_layout"
  }, [_c('Layout', {
    attrs: {
      "collapsible": ""
    }
  }, [_c('Pheard', {
    attrs: {
      "collapsed": _vm.collapsed
    },
    on: {
      "collapsedSider": _vm.collapsedSider
    }
  }), _c('Layout', {
    staticClass: "home_layout"
  }, [_c('Sider', {
    ref: "sider",
    staticClass: "sider",
    class: {
      'sider-mobile': _vm.isMobile,
      'sider-mobile-overlay': _vm.isWorkbenchMobileMenuOverlay
    },
    attrs: {
      "hide-trigger": "",
      "collapsible": "",
      "collapsed-width": _vm.collapsedWidth,
      "width": 208
    },
    model: {
      value: _vm.collapsed,
      callback: function ($$v) {
        _vm.collapsed = $$v;
      },
      expression: "collapsed"
    }
  }, [_c('Menu', {
    ref: "menu",
    staticClass: "sider_menu",
    class: {
      'sider_menu--mgt': _vm.activeLink.startsWith('/MGT')
    },
    attrs: {
      "theme": "dark",
      "width": "auto",
      "open-names": _vm.openNames,
      "active-name": _vm.activeName
    }
  }, [_vm._l(_vm.menuList, function (menu, index) {
    return [menu.name != 'enterpriseHome' && menu.children && menu.children.length > 0 && !_vm.collapsed ? _c('div', {
      key: 'cat-' + menu.name,
      staticClass: "iw-sidebar-category"
    }, [_vm._v(" " + _vm._s(_vm.translateMenuCategory(menu.name)) + " ")]) : index > 0 ? _c('div', {
      key: 'div-' + index,
      staticClass: "iw-sidebar-divider"
    }) : _vm._e(), menu.children && menu.children.length > 0 ? _c('Submenu', {
      key: index,
      attrs: {
        "name": menu.name
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticClass: "menu_text"
    }, [_c('span', {
      staticClass: "material-symbols-outlined menu_ms_icon"
    }, [_vm._v(_vm._s(_vm.menuIconMap[menu.name] || "folder"))]), _c('div', {
      staticClass: "menu_text_content"
    }, [_vm._v(" " + _vm._s(_vm.translateMenuLabel(menu)) + " ")])])]), _vm._l(menu.children, function (subMenu) {
      return _c('MenuItem', {
        key: subMenu.name,
        attrs: {
          "to": subMenu.link,
          "name": subMenu.name
        },
        nativeOn: {
          "click": function ($event) {
            return _vm.selectMenu(subMenu);
          }
        }
      }, [_c('div', {
        staticClass: "subMenu_text"
      }, [_c('div', {
        staticClass: "menu_text_content"
      }, [_vm._v(" " + _vm._s(_vm.translateMenuLabel(subMenu)) + " ")])])]);
    })], 2) : _c('MenuItem', {
      key: index,
      attrs: {
        "name": menu.name,
        "to": menu.link
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.selectMenu(menu);
        }
      }
    }, [_c('div', {
      staticClass: "menu_text"
    }, [_c('span', {
      staticClass: "material-symbols-outlined menu_ms_icon"
    }, [_vm._v(_vm._s(_vm.menuIconMap[menu.name] || "apps"))]), _c('div', {
      staticClass: "menu_text_content"
    }, [_vm._v(" " + _vm._s(_vm.translateMenuLabel(menu)) + " ")])])])];
  })], 2)], 1), _c('Layout', {
    ref: "contentMain",
    class: [_vm.isMobile ? 'p-[8px]' : 'p-[20px]', _vm.$route.name === 'MGT' ? 'content_main--fluid' : 'content_main']
  }, [_c('Content', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('keep-alive', [_c('router-view')], 1), _c('div', {
    attrs: {
      "id": "appContainer"
    }
  })], 1)], 1)], 1)], 1), _c('ValidPassword', {
    ref: "ValidPassword"
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };